import { CognitoUserPool } from "amazon-cognito-identity-js";

// Separate student pool (hard isolation from the admin pool).
const UserPoolId = import.meta.env.VITE_STUDENT_POOL_ID ?? "";
const ClientId = import.meta.env.VITE_STUDENT_CLIENT_ID ?? "";

let pool: CognitoUserPool | null | undefined;

/** The student pool, or null if not configured (guard: empty ids throw). */
export function getPool(): CognitoUserPool | null {
  if (pool !== undefined) return pool;
  pool = UserPoolId && ClientId ? new CognitoUserPool({ UserPoolId, ClientId }) : null;
  return pool;
}

export const isConfigured = (): boolean => getPool() !== null;

/** Current valid ID token (refreshed if needed), or null if not signed in. */
export function getIdToken(): Promise<string | null> {
  return new Promise((resolve) => {
    const user = getPool()?.getCurrentUser();
    if (!user) return resolve(null);
    user.getSession((err: Error | null, session: { isValid(): boolean; getIdToken(): { getJwtToken(): string } } | null) => {
      if (err || !session || !session.isValid()) return resolve(null);
      resolve(session.getIdToken().getJwtToken());
    });
  });
}
